import React, { useContext } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Flex } from 'ui/chandra'
import Text from 'ui/acro/typography/Text'
import MyPracticeFilter from './MyPracticeFilter'
import { getCategoryRelationships } from '../../../javascript/redux/selectors/planCategoryPlanSubcategories'
// Redux
import { clearAllFilters } from '../../../javascript/redux/actions/planEntries'

import {
  getFilteredItemLabels,
  getTotalNumberOfFilters
} from '../../components_v1/pageLevelComponents/classFinder/classFinderHelperMethods'
import { MyPracticeDetailsContext } from 'components_v2/page_context'

const FlexContainer = styled(Flex)`
  flex-direction: column;
  margin-top: 3rem;
  width: 18%;
  gap: 30px;
  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 0;
  }
`
const TopSection = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  flex: none;
  @media (max-width: 1024px) {
    display: none;
  }
`
const FilterCountSection = styled(Text)`
  color: #000;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
`
const ClearAllSection = styled('div')`
  color: #000;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%; /* 16.1px */
  text-decoration-line: underline;
  align-self: center;
  cursor: pointer;
`
const FilterContainer = styled(Flex)`
  width: 100%;
  .FilterMetaLayout {
    width: 100%;
    .FilterLabelsRow {
      margin: 0 0 0 -20px;
      width: 100%;
    }
    .FilterMetaLayout__bottomRow {
      padding-bottom: 0;
      .showing {
        display: none;
      }
      @media (min-width: 1025px) {
        display: none;
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        padding: 0;
      }
    }
    .FilterDropdownSet {
      display: flex;
    }
    .FilterMetaLayout__topRow {
      @media (max-width: 1024px) {
        display: none;
      }
    }

    @media (max-width: 1024px) {
      padding: 0 5%;
    }
  }
`

const MyPracticeLeftFilter = ({ parent_tab, currentTab, ...props }) => {
  const { classesContext, completedContext } = useContext(
    MyPracticeDetailsContext
  )
  const [selectedClassesOptions] = classesContext
  const [selectedOptions] = completedContext

  const clearAllFilters = () => {
    props.clearAllFilters()
  }
  const filteredLabels = getFilteredItemLabels({
    filteredAttributes: props.filteredAttributes,
    duration: {
      min: props.dropdownOptions.duration.min,
      max: props.dropdownOptions.duration.max
    },
    excludedFilters: [],
    categoryRelationships: props.categoryRelationships
  })
  const numberOfActiveFilters = getTotalNumberOfFilters(filteredLabels)
  return (
    <FlexContainer className='MyPracticeLeftSection'>
      <TopSection>
        <FilterCountSection>
          {numberOfActiveFilters >= 0
            ? `Filters (${numberOfActiveFilters})`
            : 'Filters'}
        </FilterCountSection>
        <ClearAllSection onClick={() => clearAllFilters()}>
          Clear All
        </ClearAllSection>
      </TopSection>
      <FilterContainer>
        <MyPracticeFilter
          withSubcategories={props.withSubcategories}
          includeFilters={props.includeFilters}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          dropdownOptions={props.dropdownOptions}
          parent_tab={parent_tab}
          currentTab={currentTab}
          fetchMyPracticeInfo={props.fetchMyPracticeInfo}
          selectedClassesOptions={selectedClassesOptions}
          selectedCompletedClassOptions={selectedOptions}
          selectedSeriesSortOption={props.selectedSeriesSortOption}
          currentUser={props.currentUser}
          totalCount={props.totalCount}
        ></MyPracticeFilter>
      </FilterContainer>
    </FlexContainer>
  )
}

const mapStateToProps = (state) => {
  return {
    filteredAttributes: state.ui.planEntries.filtered,
    categoryRelationships: getCategoryRelationships(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyPracticeLeftFilter)
